import { render } from "./HomeItsWhySogdoComp.vue?vue&type=template&id=5ba0e5be&scoped=true"
import script from "./HomeItsWhySogdoComp.vue?vue&type=script&lang=js"
export * from "./HomeItsWhySogdoComp.vue?vue&type=script&lang=js"

import "./HomeItsWhySogdoComp.vue?vue&type=style&index=0&id=5ba0e5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba0e5be"]])

export default __exports__